import request from "@/axios.js";

export class Collaborator {
	/**
	 * Collaborator class
	 * @param {object} collaborator - Collaborator object
	 * @property {string} firstname - a firstname.
	 * @property {string} lastname - a lastname.
	 * @property {string} email - an email.
	 * @property {number} role - a role.
	 * @property {string} password - a password.
	 * @property {string} phone - a phone.
	 * @property {number} type - a type.
	 * @property {number} status - a status.
	 * @property {string} commentary - a commentary.
	 * @property {string} image_url - an image_url.
	 * @property {number} hasAccess - If the user has access to the application.
	 */
	constructor(collaborator) {
		this.id = collaborator.id;
		this.firstname = collaborator.firstname;
		this.lastname = collaborator.lastname;
		this.email = collaborator.email;
		this.password = collaborator.password;
		this.phone = collaborator.phone;
		this.role = collaborator.role || 1;
		this.status = collaborator.status || 0;
		this.type = collaborator.type;
		this.commentary = collaborator.commentary;
		this.image_url = collaborator.image_url;
		this.hasAccess = collaborator.hasAccess || 1;
	}

	/**
	 * Create an object to be used for forms (on creation)
	 * @return {object} collaborator object
	 */
	static getFormFields(){
		return {
			firstname: null,
			lastname: null,
			email: null,
			phone: null,
			password: null,
			role: 1,
			status: 0,
			type: null,
			commentary: null,
			image_url: null,
			hasAccess: 1
		};
	}

	/**
	 * Request API to fetch a commercial from Rankwell
	 * @param {number} commercialId - Id of the commercial in charge of a society
	 * @param {function} callbak - Callback function to interact with error and result
	 * @return {object} commercial in rankwell
	 */
	static getCommercial(societyId, callback){
		request
			.get("users/commercial/rankwell/" + societyId)
			.then(response => {
				callback(null, response.data[0]);
			})
			.catch(err => {
				callback(err, null);
			});
	}

	/**
	 * Request API to fetch a commercial from Rankwell
	 * @param {number} commercialId - Id of the commercial in charge of a society
	 * @param {function} callbak - Callback function to interact with error and result
	 * @return {object} commercial in rankwell
	 */
	static getCommercialSociety(societyId, callback) {
		request
			.get("users/commercialsociety/rankwell/" + societyId)
			.then(response => {
				callback(null, response.data[0]);
			})
			.catch(err => {
				callback(err, null);
			});
	}

  /**
   * Request API to fetch all commercial from Rankwell
   * @param {function} callback - Callback function to interact with error and result
   * @return {object[]} List of all commercial in rankwell
   */
  static getCommercials = callback => {
  	request
  		.get("users/all/commercial/rankwell")
  		.then(response => {
  			callback(null, response.data);
  		})
  		.catch(err => {
  			callback(err, null);
  		});
  };

  compare(collaboratorToCompare){
  	for(let key in collaboratorToCompare) {
  		if(this[key] != collaboratorToCompare[key]){
  			return false;
  		}
  	}
  	return true;
  }
}
